var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('details',[_c('summary',[_c('p',{staticClass:"list"},[_vm._v(_vm._s(_setup.t('widget_info_text.expand')))])]),_c('img',{staticClass:"list-item",attrs:{"src":"images/info/expand.jpg","alt":"Expand"}}),_c('p',{staticClass:"list-item text"},[_vm._v(_vm._s(_setup.t('widget_info_text.expand_txt')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }